const state = {
  //Filters object for which match operation will be performed on each of its attributes
  filters: {
    climates: [],
    geologies: [],
    producerNames: [],
    fundingNames: [],
    fundingAcronyms: [],
    variableNames: [],
    keywordOntologies: [],
    keywordsLinkType: [],
    keywords: [],
    clustering: [],
    searchArea: "",
    minDate: "",
    maxDate: "",
    fullText: null,
    totalCount: 0,
  }, settings: {
    clustering: true,
  }
};

const getters = {
  getFilters: state => {
    return state.filters;
  },
  getSettings: state => {
    return state.settings;
  },
  /**
   * Check if all the attributes of the filter of object are empty
   */
  isFiltersEmpty: state => {
    let isEmpty = true;
    for (let filter in state.filters) {
      isEmpty =
        isEmpty &&
        (state.filters[filter] === null ||
          (typeof state.filters[filter] !== "undefined" &&
            state.filters[filter].length === 0));
    }
    return isEmpty;
  }
};

const mutations = {
  UPDATE_FILTERS_GEOLOGIES: (state, payload) => {
    if (state.filters.geologies.some(elem => elem === payload)) {
      state.filters.geologies = [
        ...state.filters.geologies.filter(elem => !elem.includes(payload))
      ];
    } else {
      state.filters.geologies.push(payload);
    }
  },
  UPDATE_FILTERS_CLIMATES: (state, payload) => {
    if (state.filters.climates.some(elem => elem === payload)) {
      state.filters.climates = [
        ...state.filters.climates.filter(elem => !elem.includes(payload))
      ];
    } else {
      state.filters.climates.push(payload);
    }
  },
  UPDATE_FILTERS_PRODUCER_NAMES: (state, payload) => {
    if (state.filters.producerNames.some(elem => elem === payload)) {
      state.filters.producerNames = [
        ...state.filters.producerNames.filter(elem => !elem.includes(payload))
      ];
    } else {
      state.filters.producerNames.push(payload);
    }
  },
  UPDATE_FILTERS_FUNDING_NAMES: (state, payload) => {
    if (state.filters.fundingNames.some(elem => elem === payload)) {
      state.filters.fundingNames = [
        ...state.filters.fundingNames.filter(elem => !elem.includes(payload))
      ];
    } else {
      state.filters.fundingNames.push(payload);
    }
  },
  UPDATE_FILTERS_FUNDING_ACRONYMS: (state, payload) => {
    if (state.filters.fundingAcronyms.some(elem => elem === payload)) {
      state.filters.fundingAcronyms = [
        ...state.filters.fundingAcronyms.filter(elem => !elem.includes(payload))
      ];
    } else {
      state.filters.fundingAcronyms.push(payload);
    }
  },
  UPDATE_FILTERS_VARIABLE_NAMES: (state, payload) => {
    if (state.filters.variableNames.some(elem => elem === payload)) {
      state.filters.variableNames = [
        ...state.filters.variableNames.filter(elem => !elem.includes(payload))
      ];
    } else {
      state.filters.variableNames.push(payload);
    }
  },/*
  UPDATE_FILTERS_KEYWORD_ONTOLOGIES: (state, payload) => {
    if (state.filters.keywordOntologies.some(elem => elem === payload)) {
      state.filters.keywordOntologies = [
        ...state.filters.keywordOntologies.filter(elem => !elem.includes(payload))
      ];
    } else {
      state.filters.keywordOntologies.push(payload);
    }
  },*/
  UPDATE_FILTERS_KEYWORD_LINK_TYPE: (state, payload) => {
    if (state.filters.keywordsLinkType.some(elem => elem === payload)) {
      state.filters.keywordsLinkType = [
        ...state.filters.keywordsLinkType.filter(elem => !elem.includes(payload))
      ];
    } else {
      state.filters.keywordsLinkType.push(payload);
    }
  },
  UPDATE_FILTERS_KEYWORDS: (state, payload) => {
    if (state.filters.keywords.some(elem => elem === payload)) {
      state.filters.keywords = [
        ...state.filters.keywords.filter(elem => !elem.includes(payload))
      ];
    } else {
      state.filters.keywords.push(payload);
    }
  },
  UPDATE_FILTERS_FULL_TEXT: (state, payload) => {
    state.filters.fullText = payload;
  },
  RESET_FILTERS: state => {
    state.filters = {
      climates: [],
      geologies: [],
      producerNames: [],
      fundingNames: [],
      fundingAcronyms: [],
      variableNames: [],
      keywordOntologies: [],
      keywordsLinkType: [],
      keywords: [],
      fullText: null
    };
  }
};

const actions = {
  /**
   * Mutate the full text filter
   */
  setFullTextFilter: (store, text) => {
    return new Promise(resolve => {
      store.commit("UPDATE_FILTERS_FULL_TEXT", text);
      resolve();
    });
  },
  /**
   * Mutate one of the bucket filter depending one the mutation name parameter.
   */
  setBucketFilter: (store, { mutationName, name }) => {
    return new Promise(resolve => {
      store.commit(mutationName, name);
      resolve();
    });
  }
};
export let filters = {
  state,
  getters,
  mutations,
  actions
};
